var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5H8.333v-1a.5.5 0 00-.5-.5H4.167a.5.5 0 00-.5.5v1H0V2h1.593c0 .017-.002.033 0 .05l.9 9.005A1.05 1.05 0 003.538 12h4.924c.54 0 .991-.409 1.045-.945l.9-9.005c.002-.017 0-.033 0-.05H12v-.5zM4.167.5h3.667v1H4.167v-1zm4.842 10.505a.548.548 0 01-.547.495H3.538a.548.548 0 01-.547-.495L2.09 2h7.82l-.9 9.005z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3h-.5v7.5h.5V3zM8 2.983l-.5 7.5.5.034.5-7.5-.5-.034zM4 2.983l-.5.034.5 7.5.5-.033-.5-7.5z",
    fill: "#333"
  })));
};

export default SvgTrash;